import { clearAuth } from "./authState";

/**
 * Single, idempotent logout. Clearing auth flips Redux `auth` to null, which the route Guard observes and uses to
 * redirect to /login — so no imperative navigation is needed here (keeps the SPA store intact). Idempotent so a
 * burst of concurrent 401s can't trigger multiple logouts.
 */
let loggingOut = false;

export async function logout(reason: "user" | "session-expired" = "user"): Promise<void> {
  if (loggingOut) return;
  loggingOut = true;
  try {
    clearAuth();
    // reason is reserved for an optional "your session expired" notice; the redirect to /login is the feedback today.
    void reason;
  } finally {
    // Release on the next tick so re-entrant 401s during the same teardown are still coalesced.
    setTimeout(() => {
      loggingOut = false;
    }, 0);
  }
}
